export const toExpandCollapse = async ({
  container,
  expand,
  containerHeight,
  childrenHeight,
  collapse,
}) => {
  const growContainer = document.getElementById(container);
  const toExpand = document.getElementById(expand);
  if (!growContainer || !toExpand) return;

  const transition = 'height 0.3s ease';
  growContainer.style.transition = transition;
  toExpand.style.transition = transition;
  toExpand.style.overflow = 'hidden';

  if (collapse) {
    toExpand.style.overflow = 'hidden';
    const currentExpandHeight = toExpand.scrollHeight || 0;
    const currentContainerHeight = growContainer.scrollHeight || containerHeight + currentExpandHeight + 10;

    growContainer.style.height = `${currentContainerHeight}px`;
    toExpand.style.height = `${currentExpandHeight}px`;

    requestAnimationFrame(() => {
      growContainer.style.height = `${containerHeight}px`;
      toExpand.style.height = '0px';
    });
  }

  if (!collapse) {
    toExpand.style.overflow = 'hidden';
    toExpand.style.height = 'auto';
    const naturalHeight = toExpand.scrollHeight || 0;
    const expandedHeight = Number(childrenHeight || naturalHeight || 0);

    growContainer.style.height = `${containerHeight}px`;
    toExpand.style.height = '0px';

    requestAnimationFrame(() => {
      growContainer.style.height = `${containerHeight + expandedHeight + 10}px`;
      toExpand.style.height = `${expandedHeight + 10}px`;
    });

    window.setTimeout(() => {
      if (toExpand.style.height !== '0px') {
        growContainer.style.height = 'auto';
        toExpand.style.height = 'auto';
        toExpand.style.overflow = 'visible';
      }
    }, 320);
  }
};
